/**
 * @generated SignedSource<<3acf9d34adc66c7755aaf5f98acbc398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedPersonalizedCategories_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedCategoryProducts_componentModule">;
  readonly " $fragmentType": "HpSharedPersonalizedCategories_componentModule";
};
export type HpSharedPersonalizedCategories_componentModule$key = {
  readonly " $data"?: HpSharedPersonalizedCategories_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedPersonalizedCategories_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedPersonalizedCategories_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedCategoryProducts_componentModule"
    }
  ],
  "type": "ArrivalsModule",
  "abstractKey": null
};

(node as any).hash = "3045e15a12cbe29f87e20b102529229b";

export default node;
